/// <reference path='../userDefinedControls.module.ts' />
/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.Plugins.UserDefinedControls {

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import IAppAreaService = Meevo.Model.IAppAreaService;
    import IAppAreaTab = Meevo.Model.IAppAreaTab;
    import IBusinessType = Meevo.Model.IBusinessType;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import UserDefinedControlsService = Meevo.Plugins.UserDefinedControls.UserDefinedControlsService;

    interface IAssignmentParams {
        appArea: AppAreaEnum,
        active: boolean,
        selectedExistingTab: IAppAreaTab | any,
        newTabName: string,
        bizType: Guid,
        selectedService?: IAppAreaService,
        isIncludedInEmailNotification?: boolean,
        isShowBookingOnline?: boolean,
        services: IAppAreaService[]
    }

    interface IAllTabs {
        // keys: AppAreaEnum values
        // values: Array<IAppAreaTab>
    }

    enum SavePlaceEnum {
        Tab,
        Service
    }

    class AssignControlModalController {
        private allTabs: IAllTabs;
        private emptyTab: IAppAreaTab = {
            appAreaEnum: AppAreaEnum.None,
            isMain: false,
            displayName: '',
            objectStateEnum: ObjectStateEnum.Active
        };
        private buisnessTypesCount: number;

        public selectedControls: Array<IUserDefinedControl>;
        public selectedControlsCopy: Array<IUserDefinedControl>;
        public controlLocations: Object;
        /*
        * Defining default value for business type:
        * "new Guid('0')" means that no business type is selected
        * "null" means that all business types are selected
        */
        public bizTypeEmptyValue = new Guid('0');
        public assignmentParams: IAssignmentParams = {
            appArea: null,
            active: true,
            selectedExistingTab: null,
            newTabName: '',
            bizType: this.bizTypeEmptyValue,
            selectedService: null,
            isIncludedInEmailNotification: false,
            isShowBookingOnline: false,
            services: []
        };
        public hasRequired: boolean = false;
        public groupedTabs: Array<IAppAreaTab>; // grouped tabs for selected App Area
        public groupedTabsFiltered: Array<IAppAreaTab>; // grouped tabs for selected App Area by Business Type
        public businessTypes: Array<IBusinessType>;
        public savePlace: SavePlaceEnum = SavePlaceEnum.Tab;
        public servicesSearchCriteria: Object;
        private _unsupportedUDFTypesForBooking: Object = {
            [ControlTypeEnum.DropDown]: 0,
            [ControlTypeEnum.Radio]: 1,
            [ControlTypeEnum.DatePicker]: 2,
            [ControlTypeEnum.ImageUpload]: 3,
            [ControlTypeEnum.DocumentUpload]: 4
        };
        public serviceLabel: string = 'LABEL_SERVICE_NAME';
        public serviceName: string;
        public checkedService: IAppAreaService;

        static $inject = [
            '$scope',
            '$q',
            '$mdDialog',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.plugins.userDefinedControls.userDefinedControlsService',
            'meevo.components.common.IdentityService'
        ];

        constructor(
            protected $scope: ng.IScope,
            protected $q: ng.IQService,
            protected $mdDialog: ng.material.IDialogService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected userDefinedControlsService: Meevo.Plugins.UserDefinedControls.IUserDefinedControlsService,
            protected identityService: Meevo.Components.Common.IIdentityService
        ) {
            this.busyService.start();
            this.$q.all([
                this.getAllTabs(),
                this.getBusinessTypes()
            ])
                .finally(() => {
                    // save selected controls
                    this.selectedControlsCopy = angular.copy(this.selectedControls);
                    this.busyService.stop();
                });

            this.selectedControls.map((item) => {
                item['parsedControlTypeDisplay'] = UserDefinedControlsService.getControlTypeName(item.controlTypeEnum);

                if (item.isRequired) {
                    this.hasRequired = true;
                }
            });
            this.controlLocations = this.userDefinedControlsService.controlLocations;
            this.assignmentParams.selectedExistingTab = angular.merge({}, this.emptyTab);
            this.addWatchers();
        }

        /**
         * Fetch list of all tabs for all areas
         * @returns {ng.IPromise<any>} promise
         * */
        private getAllTabs(): ng.IPromise<any> {
            return this.dataService.getListPaged('CustomData/Tab', {
                criteria: {
                    objectStateEnums: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                    includeControls: true
                }
            })
                .then((data: IAllTabs | any) => {
                    this.allTabs = data;
                })
        }

        /**
         * Fetch list of business types
         * @returns {ng.IPromise<any>} promise
         * */
        private getBusinessTypes(): ng.IPromise<any> {
            return this.dataService.getCount('BusinessType', {
                criteria: {
                    IncludeAllBusinessTypeListItem: false
                }
            }).then((res: number) => {
                let criteria = res === 1 ? {
                    IncludeAllBusinessTypeListItem: false
                } : null;

                return this.dataService.getListPaged('userbusinesstype', {
                    pageNumber: 0,
                    itemsPerPage: 100,
                    criteria
                }).then((data: Array<IBusinessType> | any) => {
                    data.forEach((item: IBusinessType) => {
                        if (item.id === '00000000-0000-0000-0000-000000000001') {
                            item.id = null;
                        }
                    });


                    this.businessTypes = data;

                    if (this.businessTypes.length === 1) {
                        this.assignmentParams.bizType = null;
                    }
                });
            });

        }

        /**
         * Add watchers to controller variables
         * */
        private addWatchers(): void {
            this.$scope.$watch(() => this.assignmentParams.selectedExistingTab, this.selectedTabChanged.bind(this));
            this.$scope.$watch(() => this.assignmentParams.appArea, this.appAreaChanged.bind(this));
            this.$scope.$watch(() => this.assignmentParams.newTabName, this.tabNameChanged.bind(this));
            this.$scope.$watch(() => this.assignmentParams.selectedService, this.serviceChanged.bind(this));
        }

        /**
         * Perform checks before assignment
         * */
        public tryToAssign(): void {
            if (this.savePlace === SavePlaceEnum.Tab) {
                // first check: if we have required fields and selected tab is not main
                if (this.hasRequired && this.assignmentParams.selectedExistingTab.isMain === false) {
                    this.modalService.alert('ERROR_ASSIGN_REQUIRED_NOT_TO_MAIN', ModalTranslationModes.Translate);
                    return;
                }
            }

            this.assign();
        }

        public changedSelectedService(service: IAppAreaService): void {
            if  (service) {
                this.assignmentParams.services.push(service);
                this.checkedService = service;
                this.serviceName = service.displayName;

                // Changing criteria service list
                this.servicesSearchCriteria = {
                    'BusinessTypeId': this.assignmentParams.bizType,
                    'ExcludeIdList': this.assignmentParams.services.map(service => service.id) || []
                };
            }
            this.assignmentParams.selectedService = null;

            this.changingServiceName();
        }

        public removeService(item: IAppAreaService): void {
            let index = this.assignmentParams.services.indexOf(item);
            this.assignmentParams.services.splice(index, 1);
            this.selectedControls = this.selectedControlsCopy;
            this.checkedService = this.serviceName = null;
            this.servicesSearchCriteria = {
                'ExcludeIdList': this.assignmentParams.services.map(service => service.id) || []
            };
            this.changingServiceName();
        }

        public checkService(service: IAppAreaService): void {
            this.serviceName = service.displayName;
            if (this.checkedService === service) {
                return;
            } else {
                this.checkedService = service;
                this.getSelectedServiceList(this.checkedService.id);
            }
        }

        changingServiceName(): void {
            this.serviceLabel = this.assignmentParams.services.length > 1 ? 'LABEL_MULTIPLE_NAME' : 'LABEL_SERVICE_NAME';
        }

        /**
         * Prepare data for assignment control(s)
         * @returns {Object}
         * */
        private prepareData(): Object {
            if (this.assignmentParams.appArea === AppAreaEnum.Booking) {
                this.selectedControls.forEach((userDefinedControl: IUserDefinedControl) => {
                    if (userDefinedControl.appAreaEnum === AppAreaEnum.None) {
                        userDefinedControl.isIncludedInEmailNotification = this.assignmentParams.isIncludedInEmailNotification;
                        userDefinedControl.isShowBookingOnline = this.assignmentParams.isShowBookingOnline;
                    }
                });
            }

            let data: Object = {
                controls: this.selectedControls
            };

            if (this.savePlace === SavePlaceEnum.Tab) {
                angular.extend(data, {
                    tab: {
                        'objectStateEnum': this.assignmentParams.active ? ObjectStateEnum.Active : ObjectStateEnum.Inactive,
                        'appAreaEnum': this.assignmentParams.appArea
                    }
                });

                // prepare data for create new tab
                if (this.assignmentParams.newTabName) {
                    angular.extend(data['tab'], {
                        'displayName': this.assignmentParams.newTabName,
                        'title': this.assignmentParams.newTabName
                    });
                } else {
                    // prepare date for assign control(s) to existing tab
                    angular.extend(data['tab'], {
                        'tab_TId': this.assignmentParams.selectedExistingTab.tab_TId,
                        'entityVersion': this.assignmentParams.selectedExistingTab.entityVersion,
                        'displayName': this.assignmentParams.selectedExistingTab.displayName,
                        'title': this.assignmentParams.selectedExistingTab.title
                    });
                }

                // check if we need to send business type
                if (this.isBusinessTypeVisible()) {
                    data['tab']['businessType_TId'] = this.assignmentParams.bizType;
                } else if(this.identityService.current().isSingleLocation){
                    data['tab']['businessType_TId'] = this.identityService.current().businessTypeId;
                } else if (this.businessTypes.length === 1) {
                    // NOTE: for multi location with one BT
                    data['tab']['businessType_TId'] = this.businessTypes[0].id;
                } else {
                    data['tab']['businessType_TId'] = null;
                }
            } else if (this.savePlace === SavePlaceEnum.Service) {
                angular.extend(data, {
                    'appAreaEnum': this.assignmentParams.appArea,
                    'serviceListIds': this.assignmentParams.services.map(service => service.id) || [],
                    'objectStateEnum': this.assignmentParams.active ? ObjectStateEnum.Active : ObjectStateEnum.Inactive
                });
            }

            return data;
        }

        /**
         * Assign list of UDFs to selected app area and tab
         * */
        private assign(): void {
            const isCheckoutArea = this.assignmentParams.appArea === AppAreaEnum.Checkout;
            const hasRequired = this.selectedControls.find((control) => control.isRequired);
            if ( isCheckoutArea && hasRequired ) {
                this.modalService.alert('MESSAGE_UDF_ASSIGN_TO_CHECKOUT_ERROR', Meevo.Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            this.selectedControls.map((item, index) => {
                item['sortOrder'] = index;
            });

            this.busyService.start();
            this.dataService.add(`CustomData/${SavePlaceEnum[this.savePlace]}`, this.prepareData())
                .then((response) => {
                    if (response['isWarning']) {
                        this.modalService
                            .alert(response.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    } else {
                        this.$mdDialog.hide();
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        };

        /**
         * Reorder controls
         * @param {IUserDefinedControl} control
         * @param {number} direction - available values 1, -1
         * */
        public moveControl(control: IUserDefinedControl, direction: number): void {
            let index = this.selectedControls.indexOf(control);

            UserDefinedControlsService.moveItem(this.selectedControls, index, index + direction);
        }

        /**
         * Remove control from assigning process
         * @param {IUserDefinedControl} control
         */
        public removeControl(control: IUserDefinedControl): void {
            let index = this.selectedControls.indexOf(control),
                indexCopy = this.selectedControlsCopy.indexOf(control);

            this.selectedControls.splice(index, 1);
            this.selectedControlsCopy.splice(indexCopy, 1);

            this.hasRequired = false;

            for (let i = 0, len = this.selectedControlsCopy.length; i < len; i++) {
                if (this.selectedControlsCopy[i].isRequired) {
                    this.hasRequired = true;
                    break;
                }
            }
        }

        /**
         * user selects some business type in select box
         */
        public businessTypeChanged(): void {
            // set search criteria for type ahead on services
            this.servicesSearchCriteria = {
                'BusinessTypeId': this.assignmentParams.bizType
            };

            this.assignmentParams.selectedService = null;
            this.assignmentParams.services = [];
            this.selectedControls = this.selectedControlsCopy;

            // tabs are filtered by business type
            if (this.isBusinessTypeVisible()) {
                this.assignmentParams.selectedExistingTab = angular.merge({}, this.emptyTab);

                // null - all business types (no data is assigned to 'businessType_TId')
                if (this.assignmentParams.bizType === null) { // all Business Type
                    this.groupedTabsFiltered = this.groupedTabs.filter(t => !t.businessType_TId);
                } else {
                    this.groupedTabsFiltered = this.groupedTabs.filter(t => t.businessType_TId === this.assignmentParams.bizType);
                }

                // pre-select Main tab with selected business type if UDF is required (can only be put on main tab)
                if (this.hasRequired) {
                    this.groupedTabsFiltered = this.groupedTabsFiltered.filter(t => t.isMain);

                    if (this.groupedTabsFiltered.length) {
                        this.assignmentParams.selectedExistingTab = this.groupedTabsFiltered[0];
                        this.extendControlsWithinTab();
                    }
                }
            }
        }

        /**
         * Select Existing Tab
         * @param {IAppAreaTab} existingTab
         * @param {IAppAreaTab} prevTab
         */
        private selectedTabChanged(existingTab, prevTab): void {
            if (existingTab === prevTab || !existingTab) {
                return;
            }

            if (existingTab.isMain) {
                this.assignmentParams.active = true;
            } else {
                this.assignmentParams.active = existingTab.objectStateEnum === ObjectStateEnum.Active;
            }

            this.extendControlsWithinTab(existingTab);
            this.setSelectedBusinessType(existingTab);
        }

        /**
         * Set Selected Business Type
         * @param {IAppAreaTab} tab
         */
        private setSelectedBusinessType(tab: IAppAreaTab = this.assignmentParams.selectedExistingTab): void {
            if ((this.isBusinessTypeVisible()) && tab.tab_TId) {
                this.assignmentParams.bizType = tab.businessType_TId || null;
            }
        }

        /**
         * Select new app area
         * @param {AppAreaEnum} newAppArea
         * @param {AppAreaEnum} prevAppArea
         * */
        private appAreaChanged(newAppArea, prevAppArea): void {
            if (newAppArea === prevAppArea) {
                return;
            }
            this.groupedTabs = this.allTabs[newAppArea];
            this.groupedTabsFiltered =  this.businessTypes.length === 1 ? this.groupedTabs.filter((t) => !!t.businessType_TId) : angular.copy(this.groupedTabs);
            this.assignmentParams.bizType = this.businessTypes.length === 1 ? null : this.bizTypeEmptyValue;
            this.assignmentParams.selectedExistingTab = angular.merge({}, this.emptyTab);
            this.assignmentParams.services = [];

            // define place for save
            if (this.assignmentParams.appArea === AppAreaEnum.Checkout || this.assignmentParams.appArea === AppAreaEnum.Booking
                || this.assignmentParams.appArea === AppAreaEnum.Checkin) {
                this.savePlace = SavePlaceEnum.Service;
            } else {
                this.savePlace = SavePlaceEnum.Tab;
            }

            this.assignmentParams.selectedService = null;

            if (this.hasTabs) {
                // pre-select Main tab if UDF is required (can only be put on main tab)
                if (this.hasRequired) {
                    this.assignmentParams.selectedExistingTab = _.find(this.groupedTabsFiltered, t => t.isMain);
                }
            }

            // check if the user has access to business type(s)
            if (this.isBusinessTypeVisible()) {
                if (!this.businessTypes.length) {
                    this.modalService.alert('LABEL_YOU_ARE_NOT_CONFIGURED_TO_MANAGE_ANY_BUSINESS_TYPE', ModalTranslationModes.Translate).then(() => {
                        this.$mdDialog.cancel();
                    });
                }
            }
        }

        /**
         * User type in 'Create New Tab' field
         * @param {string} newName
         * @param {string} prevName
         */
        private tabNameChanged(newName: string, prevName: string): void {
            if (newName === prevName) {
                return;
            }

            if (newName) {
                this.selectedControls = this.selectedControlsCopy;
            } else {
                if (this.assignmentParams.selectedExistingTab.isMain) {
                    this.assignmentParams.active = true;
                }
                this.extendControlsWithinTab();
            }
        }

        /**
         * Extend controls within tab
         * @param {IAppAreaTab} areaTab
         * */
        private extendControlsWithinTab(areaTab: IAppAreaTab = this.assignmentParams.selectedExistingTab): void {
            let selectedTab: IAppAreaTab | any,
                controlsWithinTab: Array<IUserDefinedControl>;

            // get all controls within selected tab
            selectedTab = _.find(this.allTabs[this.assignmentParams.appArea], (val) => {
                return val['tab_TId'] === areaTab['tab_TId']
            });

            if (typeof selectedTab === 'undefined') {
                this.selectedControls = this.selectedControlsCopy;
                return;
            }

            controlsWithinTab = selectedTab['controls'];

            if (controlsWithinTab && controlsWithinTab.length) {
                controlsWithinTab.map((item) => {
                    item['parsedControlTypeDisplay'] = UserDefinedControlsService.getControlTypeName(item.controlTypeEnum);
                });

                this.selectedControls = controlsWithinTab.concat(this.selectedControlsCopy);

            } else {
                this.selectedControls = this.selectedControlsCopy;
            }
        }

        /**
         * User selects another service from typeAhead control
         * @param {IAppAreaService} newService
         * @param {IAppAreaService} prevService
         */
        private serviceChanged(newService: IAppAreaService, prevService: IAppAreaService): void {
            // avoid useless changes
            if (newService === prevService) {
                return;
            }

            // check if service isn't selected
            if (!newService) {
                this.selectedControls = this.selectedControlsCopy;
                return;
            }

            this.getSelectedServiceList(this.assignmentParams.selectedService.id);
        }

        public getSelectedServiceList(serviceId: Guid): void {
            this.dataService.getListPaged(`CustomData/Service/${serviceId}/Control`, {
                pageNumber: 0,
                itemsPerPage: 100000,
                sortBy: 'sortOrder',
                sortDirection: Meevo.Model.SortDirection.Ascending,
                criteria: {
                    appAreaEnum: this.assignmentParams.appArea,
                    service_TId: serviceId
                }
            })
                .then((data: Array<IUserDefinedControl> | any) => {
                    data.controls.map((item) => {
                        item['parsedControlTypeDisplay'] = UserDefinedControlsService.getControlTypeName(item.controlTypeEnum);
                    });

                    this.selectedControls = data.controls.concat(this.selectedControlsCopy);
                });
        }

        /**
         * Checkbox "Show when Booking Online" changed
         */
        public showWhenOnlineBookingCheckboxChanged(): void {
            if (this.assignmentParams.isShowBookingOnline && this.assignmentParams.appArea === AppAreaEnum.Booking && this.isUnsupportedUDFPresented()) {
                // Alert message when placing unsupported UDF(s) on Online Booking
                this.modalService.alert('MESSAGE_HIGHLIGHTED_FIELDS_ARE_NOT_SUPPORTED', ModalTranslationModes.Translate, true);
                if (this.selectedControlsCopy.every((control: IUserDefinedControl) => {
                    return control.controlTypeEnum in this._unsupportedUDFTypesForBooking;
                })) {
                    this.assignmentParams.isShowBookingOnline = false;
                }
                return;
            }
        }

        /**
         * Check if unsupported udf is presented in selection or check particular control
         * @param {IUserDefinedControl} [control]
         * @returns {boolean}
         */
        public isUnsupportedUDFPresented(control?: IUserDefinedControl): boolean {
            if (control) {
                return control.controlTypeEnum in this._unsupportedUDFTypesForBooking;
            }

            return this.selectedControls.some((control: IUserDefinedControl) => {
                return control.controlTypeEnum in this._unsupportedUDFTypesForBooking;
            });
        }

        /**
         * Check if a User can select Business Type
         * @returns {boolean}
         */
        public isBusinessTypeVisible(): boolean {
            return (this.businessTypes || []).length > 1 &&
                (
                    this.assignmentParams.appArea === AppAreaEnum.Employee ||
                    this.assignmentParams.appArea === AppAreaEnum.Client ||
                    this.assignmentParams.appArea === AppAreaEnum.Product ||
                    this.assignmentParams.appArea === AppAreaEnum.Service ||
                    this.savePlace === SavePlaceEnum.Service
                );
        }

        get hasTabs(): boolean {
            return this.assignmentParams.appArea === AppAreaEnum.Employee
                || this.assignmentParams.appArea === AppAreaEnum.Client
                || this.assignmentParams.appArea === AppAreaEnum.Product
                || this.assignmentParams.appArea === AppAreaEnum.Service;
        }

        get appAreaEnum(): any {
            return AppAreaEnum;
        }

        get SavePlaceEnum(): any {
            return SavePlaceEnum;
        }

        get selectExistingTabDisabled(): boolean {
            return this.assignmentParams.newTabName !== ''
                || this.hasRequired
                || (this.isBusinessTypeVisible() && this.assignmentParams.bizType === this.bizTypeEmptyValue);
        }
    }

    angular.module('meevo.plugins.userDefinedControls')
        .controller('meevo.plugins.userDefinedControls.AssignControlModalController', AssignControlModalController);
}
